import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const InitSwiper = () => {
  const swiperHero = document.querySelector('[data-component="swiper-hero"]');
  if (!swiperHero) {
    return;
  }
  const swiperSlides = document.querySelectorAll('.swiper-slide');
  const swiperOptions = {
    // slidesPerView: 1,
    // autoHeight: true,
    // loop: true,
    // modules: [Navigation, Pagination, Autoplay, EffectFade],
    // speed: 1000,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true,
    // },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
      renderBullet(index, className) {
        return (
          '<span class="' +
          className +
          '">' +
          '<em>' +
          swiperSlides[index].dataset.title +
          '</em>' +
          '<i></i>' +
          '<b></b>' +
          '</span>'
        );
      },
    },
  };

  const swiper = new Swiper(swiperHero, swiperOptions);
};

export default InitSwiper;
